import { useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useLogin } from '@/features/auth/hooks'
import { ApiError } from '@/lib/apiClient'
import { Button } from '@/components/ui/Button'
import { Notice } from '@/components/ui/Feedback'
import { PasswordField } from '@/components/ui/PasswordField'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const formRef = useRef<HTMLFormElement>(null)
  const login = useLogin()
  const navigate = useNavigate()
  const location = useLocation()

  const requestedRedirect = new URLSearchParams(location.search).get('redirect')
  const redirectTo = requestedRedirect?.startsWith('/') && !requestedRedirect.startsWith('//') ? requestedRedirect : '/perfil'

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    setSubmitted(true)
    if (!email.trim() || !password) {
      requestAnimationFrame(() => formRef.current?.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus())
      return
    }
    login.mutate({ email, password }, { onSuccess: () => navigate(redirectTo, { replace: true }) })
  }

  return (
    <div className="auth-page">
      <header className="flow-heading">
        <p className="eyebrow">Compra protegida</p>
        <h1>Ingresa a tu cuenta</h1>
        <p>Al continuar podrás administrar tus empresas y licencias.</p>
      </header>

      <form ref={formRef} noValidate onSubmit={handleSubmit} className="form-panel">
        <div className="form-field">
          <label htmlFor="login-email">Correo electrónico</label>
          <input
            id="login-email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            aria-invalid={submitted && !email.trim()}
            aria-describedby={submitted && !email.trim() ? 'login-email-error' : undefined}
          />
          {submitted && !email.trim() && <p id="login-email-error" className="field-error" role="alert">Escribe tu correo electrónico.</p>}
        </div>

        <PasswordField label="Contraseña" autoComplete="current-password" value={password} onChange={setPassword}
          minLength={1} error={submitted && !password ? 'Escribe tu contraseña.' : undefined} />

        {login.isError && (
          <Notice>
            {login.error instanceof ApiError ? login.error.message : 'No pudimos iniciar sesion.'}
          </Notice>
        )}

        <Button type="submit" busy={login.isPending}>Ingresar</Button>
      </form>

      <p className="flow-footnote"><Link to="/restablecer-contrasena">¿Olvidaste tu contraseña?</Link></p>
      <p className="flow-footnote">
        ¿Primera compra? <Link to={`/registro?redirect=${encodeURIComponent(redirectTo)}`}>Crea tu cuenta</Link>.
      </p>
    </div>
  )
}

